class IdleService {
  static get inactiveSeconds() {
    return (new Date() - IdleService.startTime) / 1000;
  }

  static resetTimer() {
    IdleService.startTime = new Date();
    if (IdleService.onResetCallback.length) {
      IdleService.onResetCallback.forEach((cb) => cb());
    }
  }

  static onSubscribeResetTimer(callback) {
    if (IdleService.onResetCallback) {
      IdleService.onResetCallback.push(callback);
    }
  }

  static ifInactive(secondsCount, callback, once = true) {
    const interval = setInterval(() => {
      if (IdleService.inactiveSeconds >= secondsCount) {
        callback();
        if (once) clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }
}

document.addEventListener('mousedown', IdleService.resetTimer); // add check of unfocusForInactivity config here
document.addEventListener('keypress', IdleService.resetTimer);

IdleService.startTime = new Date();
IdleService.onResetCallback = [];

export default IdleService;
